/* eslint-disable no-unsafe-optional-chaining */
import { createSlice } from '@reduxjs/toolkit'
import { _Object } from 'utils/interfaces'

const initialState: _Object = {
  cart: {
    customer: {},
    lineItems: [],
    categories: [],
    setCustomerId: ''
  },
}

const cartSlice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.cart.customer = action?.payload
    },
    setCustomerId: (state, action) => {
      state.cart.setCustomerId = action?.payload
    },
    addToCart: (state, action) => {
      const payload = action?.payload;
      if (!payload) return;

      // Case 1: Clearing cart with empty array []
      if (Array.isArray(payload) && payload.length === 0) {
        state.cart.lineItems = [];
        localStorage.setItem('cartLineItems', JSON.stringify([]));
        return;
      }

      // Case 2: Array of items (e.g. restoring saved cart or held order)
      if (Array.isArray(payload) && payload.length > 0) {
        payload.forEach((item: any) => {
          if (!item) return;
          const itemId = item.id ?? item._id;
          const itemInCart = state.cart.lineItems.find((ci: any) => (ci.id ?? ci._id) === itemId);
          const qtyToAdd = Number(item.quantity) || 1;
          if (itemInCart) {
            itemInCart.quantity = (Number(itemInCart.quantity) || 0) + qtyToAdd;
          } else {
            state.cart.lineItems.push({ ...item, id: itemId, quantity: qtyToAdd });
          }
        });
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
        return;
      }

      // Case 3: Single item object
      if (typeof payload === 'object') {
        const itemId = payload.id ?? payload._id;
        const itemInCart = state.cart.lineItems.find((ci: any) => (ci.id ?? ci._id) === itemId);
        const qtyToAdd = Number(payload.quantity) || 1;

        if (itemInCart) {
          itemInCart.quantity = (Number(itemInCart.quantity) || 0) + qtyToAdd;
        } else {
          state.cart.lineItems.push({ ...payload, id: itemId, quantity: qtyToAdd });
        }
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },

    lineItemDiscount: (state, action) => {
      const itemIndex = state.cart.lineItems.findIndex((cartItem: _Object) => (cartItem.id ?? cartItem._id) === (action.payload.clickedItem.id ?? action.payload.clickedItem._id));

      if (itemIndex !== -1) {
        state.cart.lineItems[itemIndex].discount = action.payload.values.amount;
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },

    cartLineItemDiscount: (state, action) => {
      state.cart = { ...state.cart, discount: action.payload.amount };
    },

    incrementQuantity: (state, action) => {
      const item = state.cart.lineItems.find((item: _Object) => (item.id ?? item._id) === action.payload);
      if (item) {
        item.quantity = (Number(item.quantity) || 0) + 1;
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },
    decrementQuantity: (state, action) => {
      const item = state.cart.lineItems.find((item: _Object) => (item.id ?? item._id) === action.payload);
      if (item && item.quantity > 1) {
        item.quantity = Number(item.quantity) - 1;
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },
    setQuantity: (state, action) => {
      const item = state.cart.lineItems.find((item: _Object) => (item.id ?? item._id) === action.payload.id);
      if (item) {
        item.quantity = action.payload.quantity > 1 ? Number(action.payload.quantity) : 1;
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },
    removeCartItem: (state, action) => {
      if (action?.payload?.reverse) {
        state.cart.lineItems?.splice(state.cart.lineItems.length - action.payload.index - 1, 1);
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      } else {
        state.cart.lineItems.splice(action.payload, 1);
        localStorage.setItem('cartLineItems', JSON.stringify(state.cart.lineItems));
      }
    },

  },
})

export const { setCustomer, setCustomerId, addToCart, lineItemDiscount, incrementQuantity, cartLineItemDiscount, decrementQuantity, removeCartItem, setQuantity, } = cartSlice.actions;

export default cartSlice.reducer
